import { React, useEffect, useRef, useState } from "react";
import { BiChevronDown } from "react-icons/bi";

const BasicSelector = ({
  listItem = [],
  children,
  border = true,
  onSelected,
  label,
  defaultValue,
  withArrow = true,
  withChangeLabel = true,
  size = "sm",
  className,
}) => {
  const [listLabel, setListLabel] = useState(defaultValue || label);
  const [openList, setOpenList] = useState(false);
  const dropdownRef = useRef(null);

  const customStyle = border
    ? "rounded-xl border border-slate-200 bg-white px-3 py-2 text-slate-700 shadow-sm"
    : "px-3 py-1";

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpenList(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  useEffect(() => {
    setListLabel(defaultValue || label);
  }, [defaultValue, label]);

  return (
    <div
      ref={dropdownRef}
      className={`relative flex flex-col px-3 ${className}`}
    >
      <div
        onClick={() => setOpenList(!openList)}
        className={`flex cursor-pointer items-center justify-between gap-2 whitespace-nowrap text-xs transition-all ${
          size === "lg" ? "h-10 text-sm" : "text-[15px]"
        } ${customStyle} hover:border-[#251658]/20 hover:bg-[#251658]/5 hover:text-[white]`}
      >
        {children} {label && listLabel}
        {withArrow && <BiChevronDown />}
      </div>

      {listItem.length > 0 && (
        <ul
          style={{ color: "#374151" }}
          className={`absolute top-full z-50 mt-2 min-w-[140px] rounded-2xl border border-slate-200 bg-white text-center text-sm shadow-lg transition-all duration-200 ${
            openList ? "opacity-100 visible" : "opacity-0 invisible"
          }`}
        >
          {listItem.map((item, index) => (
            <li
              onClick={() => {
                onSelected(item);
                setOpenList(false);
                withChangeLabel && setListLabel(item.label);
              }}
              key={index}
               className={`cursor-pointer p-2 transition-colors hover:bg-[#251658]/5 hover:text-[#251658] ${
                 listItem.length > 0 && listItem.length !== index + 1
                   ? "border-b"
                   : ""
              }`}
            >
              {item.label}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default BasicSelector;
